// extracted by mini-css-extract-plugin
module.exports = {"root":"root__19bE9","like":"like__3vX3D","dislike":"dislike__2I_ey","counter":"counter__GS4OA"};